import SuccessMessages from './SuccessMessages';

export default SuccessMessages;
